import * as React from "react";
import { styled } from "@mui/system";
import { TreeItem as MUITreeItem } from "@mui/x-tree-view/TreeItem";
import { TreeItemProps } from "@mui/x-tree-view/TreeItem";

export const TreeItem: React.FC<TreeItemProps> = styled(
  React.forwardRef<HTMLLIElement, TreeItemProps>((props, ref) => (
    <MUITreeItem ref={ref} {...props} />
  )),
  {
    name: "TreeItem",
    slot: "Root",
    overridesResolver: (props, styles) => []
  }
)(({ theme }) => ({
  "&.MuiTreeItem-root .MuiTreeItem-content": {
    border: "1px solid transparent",
    background: theme.palette.primary.surfaceDefault,
    minHeight: 32,
    alignItems: "center",
    "&.Mui-selected": {
      background: theme.palette.primary.interactiveSelectedColor
    },
    "&:hover": {
      border: "1px solid " + theme.palette.primary.borderActive
    }
  },
  "&.MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-iconContainer": {
    color: theme.palette.primary.main,
    alignItems: "center",
    width: 32,
    height: 32
  },
  "&.MuiTreeItem-root .MuiTreeItem-content .MuiTreeItem-label": {
    fontSize: 14,
    color: theme.palette.primary.main,
    fontFamily: "Roboto",
    fontWeight: 700
  }
}));
